import { initPopup, initFull } from './ui';

const Chatbot = {
  init: initPopup,
  initFull,
} as const;

export default Chatbot;


